import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import Http from 'axios';
import { EventTracking, EventType } from '@app/tracking';
export default Vue.extend({
    data: function () { return ({
        loading: false,
        results: [],
        showLimit: 5,
        searchQuery: '',
        resultTypeIcons: {
            'Nitrous\\Core\\Block': 'align-left',
            'RF\\Blog\\Post': 'newspaper',
            'RF\\Event\\Event': 'calendar-alt',
            'RF\\Shopify\\Product': 'shopping-bag'
        }
    }); },
    computed: {
        isSearchOpen: function () {
            return this.$store.Search.STATE.isOpen;
        },
        filteredResults: function () {
            return this.results.slice(0, this.showLimit);
        }
    },
    created: function () {
        document.addEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    destroyed: function () {
        document.removeEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    methods: {
        search: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.searchQuery.length < 3) {
                                return [2 /*return*/];
                            }
                            this.loading = true;
                            return [4 /*yield*/, this.$helpers.debounce(500)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, Http.get("/api/search?query=" + encodeURI(this.searchQuery))];
                        case 2:
                            response = _a.sent();
                            this.loading = false;
                            this.results = response.data.map(function (item) { return item.searchResult; });
                            EventTracking.dispatch(EventType.Track, {
                                category: 'Search',
                                action: 'Results',
                                label: this.searchQuery,
                                value: this.results.length
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        handleResultClick: function (result) {
            this.close();
            EventTracking.dispatch(EventType.Track, {
                category: 'Search',
                action: 'Click',
                label: 'Result',
                value: this.getResultPathname(result)
            });
        },
        close: function () {
            this.$store.Search.ACTIONS.close();
            this.results = [];
            this.searchQuery = '';
        },
        handleGlobalKeyDownEvent: function (e) {
            if (e.keyCode == 27 /* ESC */) {
                this.close();
            }
        },
        getResultPathname: function (result) {
            var url = new URL(result.url);
            return url.pathname + url.hash;
        }
    },
    watch: {
        isSearchOpen: function (val) {
            var _this = this;
            if (val) {
                setTimeout(function () {
                    _this.$refs.input.focus();
                }, 300);
                EventTracking.dispatch(EventType.Track, {
                    category: 'Search',
                    action: 'Open',
                });
            }
        }
    },
    filters: {
        strLimit: function (value, limit) {
            if (limit === void 0) { limit = 200; }
            if (value.length > limit) {
                return value.substring(0, limit) + ' ...';
            }
            return value;
        }
    }
});
